<template>
  <div class="min-h-screen flex flex-col">
    <a href="#main-content" class="skip-link sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-white focus:text-[#003A78] focus:font-bold focus:rounded focus:shadow-lg">Skip to main content</a>
    <div v-if="!isProduction" class="env-banner" :class="'env-banner-' + envName">
      <strong>Warning:</strong> You are using a {{ envName.toUpperCase() }} version of this site. Data may not be real.
    </div>
    <AppHeader msg="Find free legal help"/>
    <div id="main-content" class="main-content relative flex flex-grow items-start container m-auto mb-50 p-[15px] mb-[15px]">
      <suspense>
      <router-view/>  <!-- views get injected here. -->
      </suspense>
      
      <router-view v-slot="{ AllServices }">
        <template v-if="AllServices">
            <keep-alive>
              <suspense >
                <component :is="AllServices"></component>
                <template #fallback>
                  <div>
                    Loading...
                  </div>
                </template>
              </suspense>
            </keep-alive>
        </template>
      </router-view>

    </div>
    <AppFooter msg="GET LEGAL HELP!" /> 
  </div>
</template>


<script>
import AppHeader from './components/AppHeader.vue'
import AppFooter from './components/AppFooter.vue'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'LUCY - Find Legal Help',
  components: {
    AppHeader,
    AppFooter,
    AllServices: defineAsyncComponent(() => import('./views/AllServices.vue')),
    ServiceSearch: defineAsyncComponent(() => import('./views/ServiceSearch.vue')),
  },
  prop: {
    msg: String
  },
  /* router code */
  data() {
    return {
      envName: process.env.VUE_APP_ENV || 'production'
    }
  },
  computed: {
    isProduction() {
      return this.envName === 'production'
    }
  },
}
</script>

<style>
@font-face {
  font-family: "RobotoSlab";
  src: local("RobotoSlab"),
  url("assets/fonts/robotoslab/RobotoSlab-VariableFont_wght.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Black";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-Black.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Black Italic";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-BlackItalic.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Bold";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Bold Italic";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-BoldItalic.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Extra Light";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-ExtraLight.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Extra Light Italic";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-ExtraLightItalic.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Italic";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-Italic.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Light";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Light Italic";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-LightItalic.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro Regular";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro SemiBold";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-SemiBold.ttf") format("truetype");
}
@font-face {
  font-family: "Source Sans Pro SemiBold Italic";
  font-weight: 400;
  font-style: normal;
  font-display: auto;
  unicode-range: U+000-5FF;
  src: local("sourcesanspro"), url("assets/fonts/sourcesanspro/SourceSansPro-SemiBoldItalic.ttf") format("truetype");
}
/* app and body base css */

#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
/*   text-align: center; */
  color: #2c3e50;
  /* margin-top: 60px; */
  /* background-color: #00A1D4; */
  background: rgba(5, 127, 167, 0.2);
  
}
body {
  font-size: 16px;
}
/* app-wide button stuff */
.btn {
  @apply font-bold py-2 px-4 rounded;
}
button.btn-blue {
  @apply bg-clcnsw-light-blue text-white;
}
button.btn-blue:hover {
  @apply bg-clcnsw-dark-blue;
}
button {
  font-family: "Source Sans Pro SemiBold", Arial, Helvetica, sans-serif !important;
}
button.btn-blue {
  color: #fff !important;
}
button.btn-blue:focus {
  outline: 2px solid white !important;
  outline-offset: 2px !important;
}


.clcnsw-heading {
  font-family: "Source Sans Pro SemiBold", Arial, Helvetica, sans-serif;
/*   font-size: 45pt; */
  color: black;
  /* letter-spacing: 54pt; */
 /*  line-height: 1.2; */
  font-size: 2.25rem; /* 36px  4xl tailwind sizing...*/
  line-height: 2.5rem; /* 40px */
}
.main-content {
    /* min-height: 500px;*/
    /* margin-bottom: 100px; */
}
.main-content p {
  font-family: "Source Sans Pro Regular", Arial, Helvetica, sans-serif;
/*   font-size: 35pt;
  line-height: 1.2; */
  color: black;
}
button {
  font-family: "Source Sans Pro SemiBold", Arial, Helvetica, sans-serif !important;
}
.accordion-button p {
  font-family: 'Source Sans Pro Regular', Arial, Helvetica, sans-serif;
/*   font-size: 30pt;
  line-height: 1.2; */
}
.accordion-body {
    font-family: 'Source Sans Pro Regular', Arial, Helvetica, sans-serif;
    line-height: 1.2;
    color: black;
}
/* npt sure why I need to add this... something is wrong with my tailwind accordion... */
.collapse.show {
  visibility: visible;
}

/* print stuff... */
.show-for-print {
  /* hide by default */
  display: none;
}
@media print {
  .show-for-print {
    /* shw when printing */
    display: block;
  }
  .hide-for-print {
    display: none;
  }
}
a.clcnsw-link {
  color: #003a78;
} 
a.clcnsw-link:hover {
  color: #057FA7;
}

/* Environment banner */
.env-banner {
  padding: 0.75rem 1rem;
  text-align: center;
  font-weight: 500;
  color: white;
}
.env-banner-development {
  background-color: #d97706;
}
.env-banner-staging {
  background-color: #057FA7;
}
.env-banner-beta {
  background-color: #7c3aed;
}
</style>












